'use client';

import type { Ref } from 'react';

import classnames from 'classnames';

import { useVisibleOnScroll } from '../../utils/scroll';
import type { ScrollAwareNavbarProps } from './ScrollAwareNavbar.types';

import styles from './ScrollAwareNavbar.module.scss';

export function ScrollAwareNavbar({
  style,
  children,
  className,
  testId = 'ui-scroll-aware-navbar',
  ref,
  ...rest
}: ScrollAwareNavbarProps & { ref?: Ref<HTMLDivElement> }) {
  const showNavbar = useVisibleOnScroll();

  return (
    <nav
      ref={ref}
      className={classnames(
        styles['navbar'],
        showNavbar && styles['navbar--visible'],
        !showNavbar && styles['navbar--toggled'],
        className,
      )}
      style={{ ...style }}
      data-testid={testId}
      {...rest}
    >
      {children}
    </nav>
  );
}
